import React from 'react'
import { Layout, SEO } from 'Common'
import {
	Intro,
	About,
	Contact,
	Projects,
	Social,
	Skills,
} from 'Components/landing'

export default () => (
	<Layout>
		<SEO />
		<Intro />
		<About />
		<Projects />
		{/* <Skills /> */}
		<Contact />
		<Social />
	</Layout>
)
